import { getPlayListVideos, getVideos } from '@/api';
import styles from './BroadcasterHomeComponent.module.scss';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import useSWRImmutable from 'swr/immutable';
import { formatDuration, timeAgo } from '@/utils/common';

const BroadcasterVideoHomeComponent: React.FC = () => {
  const router = useRouter();
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollRefVideoDiv = useRef<HTMLDivElement>(null);

  const { data: getVideosData } = useSWRImmutable(
    'videos',
    async () => {
      const res = await getVideos();
      // console.log('API response:', res); // ✅ check shape
      return res.videos;
    }
  );

  const { data: getPlaylistData } = useSWRImmutable(
    'playlists',
    async () => {
      const res = await getPlayListVideos();
      // console.log('API response:', res); // ✅ check shape
      return res.playlists;
    }
  );



  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -scrollRef.current.offsetWidth, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: scrollRef.current.offsetWidth, behavior: 'smooth' });
  };

  const scrollLeftVideo = () => {
    scrollRefVideoDiv.current?.scrollBy({ left: -scrollRefVideoDiv.current.offsetWidth, behavior: 'smooth' });
  };

  const scrollRightVideo = () => {
    scrollRefVideoDiv.current?.scrollBy({ left: scrollRefVideoDiv.current.offsetWidth, behavior: 'smooth' });
  };


  const handleVideoClick = (video: any) => {
    router.push({
      pathname: '/broadcaster/player',
      query: { id: video.id }
    });
  };
  
  const handlePlaylistClick = (video: any) => {
    router.push({
      pathname: '/broadcaster/playlistPlayer',
      query: { id: video.id }
    });
  };

  return (
    <div>
      <div className='TopPane' style={{ borderBottom: "1px solid gray" }}>
        <label className={styles.label}>Created Playlists</label>
        <div className={styles.sliderWrapper}>
          <button className={styles.arrowLeft} onClick={scrollLeft}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className={styles.videoGrid} ref={scrollRef}>
            {getPlaylistData?.map((pl, index) => (
              // <div
              //   key={index}
              //   className={styles.videocardsss}
              //   onClick={() => handlePlaylistClick(pl)}
              //   style={{ cursor: 'pointer' }}
              // >
              //   <div className={styles.thumbnailWrapper}>
              //     <video className={styles.thumbnail} poster={pl.thumbnail} muted>
              //       <source src={pl.url} type="video/mp4" />
              //       Your browser does not support the video tag.
              //     </video>
              //     <span className={styles.timestamp}>{formatDuration(pl.duration)}</span>

              //   </div>
              //   <div className={styles.cardContent}>
              //     <div className={styles.videoTitle}>{pl.title}</div>
              //     <div className={styles.subtitle}>{pl.viewsCount}&nbsp;Views • {timeAgo(pl.createdAt)}</div>
              //   </div>
              // </div>
              <div key={pl.id} className={styles.card} onClick={() => handlePlaylistClick(pl)}>
          <div className={styles.thumbWrapper}>
            <img src={pl.thumbnailUrl} alt={pl.name} />
            <span className={styles.videoCount}>{pl.videosCount} videos</span>
            <div className={styles.playOverlay}>▶ Play all</div>
          </div>
          <div className={styles.info}>
            <h3>{pl.name}</h3>
            <p className={styles.updated}>{pl.updated}</p>
            <p className={styles.viewAll}>View full playlist</p>
          </div>
        </div>
            ))}
          </div>
          <button className={styles.arrowRight} onClick={scrollRight}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
      <div className='bottomPane' style={{ paddingTop: "1%" }}>
        <label className={styles.label}>Videos</label>
        <div className={styles.sliderWrapper}>
          <button className={styles.arrowLeft} onClick={scrollLeftVideo}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className={styles.videoGrid} ref={scrollRefVideoDiv}>
            {getVideosData?.map((video, index) => (
              <div
                key={index}
                className={styles.cardsss}
                onClick={() => handleVideoClick(video)}
                style={{ cursor: 'pointer' }}
              >
                <div className={styles.thumbnailWrapper}>
                  <video className={styles.thumbnail} poster={video.thumbnail} muted>
                    <source src={video.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <span className={styles.timestamp}>{formatDuration(video.duration)}</span>

                </div>
                <div className={styles.cardContent}>
                  <div className={styles.videoTitle}>{video.title}</div>
                  <div className={styles.subtitle}>{video.viewsCount} &nbsp;Views • {timeAgo(video.createdAt)}</div>
                </div>
              </div>
            ))}
          </div>
          <button className={styles.arrowRight} onClick={scrollRightVideo}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BroadcasterVideoHomeComponent;
